module.exports = {
      id: "icon-audio-twitter-usage",
      viewBox: "0 0 25.209 25.209",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-audio-twitter",
      toString: function () {
        return this.url;
      }
    }